import React from "react";

const isLoggedIn = localStorage.getItem('token') ? true : false;

class CheckOutComponent extends React.Component {
    constructor() {
        super();
        this.state = {
            products: [],
            totalPrice: 0,
            show: false
        }
    }

    componentDidMount() {
        let {products} = this.props;
        this.setState({products})
    }

    _updateQuantityFxn(item, type) {
        this.props._updateQuantity(item, type)
    }

    callBackFxn = () => {
        this.setState({show: false})
    }


    render() {
        let {products, show} = this.state;
        let {currency, totalPrice, btnText, defaultMin} = this.props;
        return (
            <div id="divMsg" className="price-calculator hidden-menu sticky">
                <div className={'price-calculator-list'}>
                    <div className="top-calculator-head">
                        <h1>Price Estimator</h1>
                        <a id="hides" onClick={() => window.hideMenuFxn()}>CLOSE</a>
                        <a href="#" onClick={() => this.props.resetCart()}>RESET</a>
                    </div>
                    <div className="mid-calculator">
                        Use this calculator to get a rough estimated price of your order. No need to list the actual
                        items
                        when you schedule a collection, simply select your services.
                    </div>
                    <div className="pric-cla">
                        {products && products.length ? products.map((item, key) => {
                            return (
                                <div className="pric-main-box" key={key}>
                                    <div className="pric-cla-left">{item.name}</div>
                                    <div className="pric-cla-mid">
                                        <div className="input-group">
                                            <div className="qty">
                                            <span className="minus"
                                                  onClick={() => this._updateQuantityFxn(item, 'minus')}>-</span>
                                                {/*<input type="number"
                                                   className="count" name="qty"
                                                   value={item.quantity}/>*/}
                                                <span className="count">{item.quantity}</span>

                                                <span className="plus"
                                                      onClick={() => this._updateQuantityFxn(item, 'plus')}>+</span>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="pric-cla-rigt">
                                        <p className="price-calcule">{currency}{item.price.toFixed(2)}</p>
                                    </div>
                                </div>
                            )
                        }) : null}
                    </div>

                    {defaultMin > totalPrice ?
                        <div className="total-estimate-box" key={totalPrice}>
                            <div>
                                <div className="total-estimate-left"><h4>Calculate</h4></div>
                                <div className="total-estimate-right"><h5
                                    className="tolal-price-all">{currency} {defaultMin.toFixed(2)}*
                                </h5>
                                    <div className="total-estimate-right btnColor" style={{fontSize: 10}}>
                                        <b>* {currency} {defaultMin.toFixed(2)} is our minimum order</b>
                                    </div>
                                </div>
                            </div>

                        </div> :
                        <div className="total-estimate-box" key={totalPrice}>
                            <div className="total-estimate-left"><h4>Calculate</h4></div>
                            <div className="total-estimate-right"><h5
                                className="tolal-price-all">{currency} {totalPrice.toFixed(2)}*</h5>
                            </div>
                        </div>}
                </div>
                <div className="price-calcule-btn place-order">
                    {/*onClick={() => this.setState({show: true})}*/}
                    <button className="btn-cal-place btn-my" onClick={() => this.props.placeOrderRender()}>{btnText}
                        <img className="plcmg" src="/assets/img/arrow.svg"/>
                    </button>
                </div>


            </div>
        )
    }
}

export default CheckOutComponent;
